import { useTranslation } from 'react-i18next';
import { UsageWidget } from 'src/dashboard/Componets/UsageWidget';
import { EntryListWidgetSelectAccount } from 'src/common/components/Widgets/EntryListWidget/EntryListWidgetSelectAccount';
import { Widget } from 'src/dashboard/Componets/Widget';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { EmptyLineOrBarChart } from 'src/common/components/Graphs/common/Graphs/EmptyLineOrBarChart';
import { Line } from 'react-chartjs-2';
import { DoughnutSelectUserCard } from 'src/common/components/Graphs/common/Graphs/components/DoughnutSelectUserCard';

const StyledChartContainer = styled(Box)(() => ({
  height: '100%',
}));

export const UsageChartPlaceholder = () => {
  const { t } = useTranslation();

  return (
    <UsageWidget title={t('dashboard.cumulativeUsageChart.title')}>
      <StyledChartContainer>
        <EmptyLineOrBarChart
          as={Line}
          emptyChartText={t('dashboard.placeholders.selectSingleAccount')}
        />
      </StyledChartContainer>
    </UsageWidget>
  );
};

export const ActiveStateChartPlaceholder = ({ title }: { title: string }) => {
  return (
    <Widget title={title}>
      <EntryListWidgetSelectAccount multipleAccountSelected />
    </Widget>
  );
};

export const SubscriptionStateChartPlaceholder = ({ title }: { title: string }) => {
  return (
    <Widget title={title}>
      <DoughnutSelectUserCard multipleAccountSelected />
    </Widget>
  );
};

export const PerformanceChartPlaceholder = ({ timeXAxisLabels }: { timeXAxisLabels: string[] }) => {
  const { t } = useTranslation();
  return (
    <Widget title={t('rSimInventory.rsimPerformance')}>
      <EmptyLineOrBarChart
        as={Line}
        emptyChartText={t('dashboard.placeholders.selectSingleAccount')}
        xAxisLabels={timeXAxisLabels}
      />
    </Widget>
  );
};
